export  class PrintLedgerParamsModel
{
  PatientID: string;
  EnterpriseID: string;
  LOCID: number;
  ReportId: string;
  isHideVoided: boolean;
  UserId: string;
}